module.exports = __webpack_public_path__ + "static/media/upload.0a032e8d.svg";